import CTLBooleanCell from "application/components/CTLBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "lg",
  enableAddButton: true,
  settingsMode: false,
  enableAdvanceSearch: true,
  modes: [],
};

const operationURLS = {
  create: "acd/create",
  update: "acd/update",
  list: "acd/list",
  delete: "acd/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Extension",
      accessor: "extension",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "From Extension",
      accessor: "from",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "To Extension",
      accessor: "to",
      displayInList: false,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Strategy",
      accessor: "strategy",
      displayInList: true,
      allowInForm: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          {
            id: "ring-all",
            description: "Ring All",
          },
          {
            id: "longest-ideal-agent",
            description: "Longest Ideal Agent",
          },
          { id: "round-robin", description: "Round Robin" },
          { id: "top-down", description: "Top Down" },
          {
            id: "agent-with-least-talk-time",
            description: "Agent With Least Talk Time",
          },
          {
            id: "agent-with-fewest-calls",
            description: "Agent with Fewest Calls",
          },
          {
            id: "sequentially-by-agent-order",
            description: "Sequentially By Agent Order",
          },
          { id: "random", description: "Random" },
          { id: "ring-progressively", description: "Ring Progressively" },
          { id: "acd", description: "ACD" },
          { id: "console", description: "Console" },
        ],
      },
    },
    {
        Header: "Recording",
        accessor: "record",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "boolean",
        controlType:"boolean",
        width: 6,
        Cell: ({ value }) => <CTLBooleanCell value={value} />,
      },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
